import { styled } from '@mui/material/styles'
import React from 'react'

import Fonts from '#/styles/Fonts'
import Colors from '#/styles/Old/Colors'

const OutputFieldsContainer = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: 30,
})

const FieldContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  margin: ({ margin }) => (margin ? '5px 10px 7px' : 0),
})

const FieldValue = styled('span')({
  minHeight: 32,
  lineHeight: '14px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: Fonts.fontSize.S,
  fontWeight: Fonts.fontWeight.normal,
})

const FieldLabel = styled('label')({
  fontSize: Fonts.fontSize.SS,
  color: Colors.textSecondary,
  margin: ({ gutters }) => (gutters ? '8px 0' : 0),
})

const VerticalOutputFields = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const VerticalFieldContainer = styled('div')({
  'display': 'flex',
  'marginBottom': ({ margin }) => (margin ? 4 : 0),
  '&:last-child': {
    marginBottom: 0,
  },
})

const VerticalFieldValue = styled('span')({
  fontSize: Fonts.fontSize.S,
})

const OutputFields = props => {
  const { fields = [], style = {}, direction = 'column', margin = true, gutters = true } = props

  switch (direction) {
    case 'column':
      return (
        <OutputFieldsContainer style={style}>
          {!!fields &&
            fields.map((s, i) => (
              <FieldContainer key={`output_field_${i}`} margin={margin}>
                {s.label && <FieldLabel gutters={gutters}>{s.label}</FieldLabel>}
                <FieldValue>{s.value}</FieldValue>
              </FieldContainer>
            ))}
        </OutputFieldsContainer>
      )
    case 'row':
      return (
        <VerticalOutputFields style={style}>
          {!!fields &&
            fields.map(
              (item, i) =>
                item.value &&
                item.value !== '-' && (
                  <VerticalFieldContainer key={`output_field_${i}`} margin={margin}>
                    <VerticalFieldValue>
                      {item.label && <b>{item.label}: </b>}
                      {item.value}
                    </VerticalFieldValue>
                  </VerticalFieldContainer>
                ),
            )}
        </VerticalOutputFields>
      )
    default:
      return null
  }
}

export default OutputFields
